'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxButton } from '@/components/01-atoms/Button/Button'
import { PhnxImageHolder } from '@/components/01-atoms/ImageHolder/ImageHolder'
import { PhnxCard } from '@/components/02-molecules/Card/Card'
import { PhnxGridpanel } from '@/components/02-molecules/Gridpanel/Gridpanel'

interface Service {
  title: string
  description: string
  link: {
    url: string
    label: string
  }
  asset: {
    src: string
    alt: string
    focus: string
  }
}

interface ServiceGridProps {
  blok: {
    preTitle: string
    title: string
    services: Array<{
      title: string
      description: string
      link: { cached_url: string }
      linkLabel: string
      asset: { filename: string; alt: string; focus: string }
    }>
  } & SbBlokData
}

const ServiceGrid: FC<ServiceGridProps> = ({ blok }) => {
  const [services, setServices] = useState<Service[]>([])

  useEffect(() => {
    if (blok.services != null) {
      const servicesArray = blok.services.map((service) => {
        return {
          title: service.title,
          description: service.description,
          link: {
            url: service.link.cached_url,
            label: service.linkLabel,
          },
          asset: {
            src: service.asset.filename,
            alt: service.asset.alt,
            focus: service.asset.focus,
          },
        }
      })
      setServices(servicesArray)
    }
  }, [blok.services])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxGridpanel
        preTitle={blok.preTitle}
        title={blok.title}
        itemsPerRow="four"
        alignment="center"
        padding={{
          unit: 'rem',
          default: true,
        }}
        items={
          <>
            {services != null && services.length > 0
              ? services.map((service, index) => (
                  <PhnxCard
                    key={index}
                    alignment="default"
                    title={service.title != null ? service.title : ''}
                    description={service.description != null ? service.description : ''}
                    button={
                      service?.link?.label != null ? (
                        <PhnxButton
                          type="link"
                          variant="quinary"
                          label={service.link.label}
                          href={service.link.url}
                        />
                      ) : null
                    }
                    asset={
                      service.asset != null ? (
                        <PhnxImageHolder
                          images={[
                            {
                              src: service.asset.src != null ? service.asset.src : '',
                              alt: service.asset.alt != null ? service.asset.alt : '',
                              focus: service.asset.focus != null ? service.asset.focus : '',
                            },
                          ]}
                        />
                      ) : null
                    }
                    link={service?.link?.url != null ? service.link.url : ''}
                    layout="vertical"
                    variant="septenary"
                  />
                ))
              : null}
          </>
        }
      />
    </div>
  )
}

export default ServiceGrid
